import type { Catalogs, Translation } from "@amtana/i18n/catalog";

// Every word of the home: its title, the greeting, the field's hint, the
// suggestion chips and the news line.

export type DashboardCopyKey = keyof typeof EN;
export type DashboardCatalog = typeof EN;

const EN = {
  screenTitle: "Dashboard · {product}",
  navDashboard: "Dashboard",
  placeholder: "Search pages, or start an analysis or a campaign",
  placeholderWithoutOutreach: "Search pages, or start an analysis",
  suggestFindLeads: "Find leads in followers",
  suggestWriteCampaign: "Write a campaign",
  suggestSearchAccounts: "Search accounts by niche",
  newsLabel: "New",
  newsText: "Buy domains and mailboxes, warmed up for you",
  goodMorning: "Good morning",
  goodAfternoon: "Good afternoon",
  goodEvening: "Good evening",
  greetingWithName: "{greeting}, {name}",
} as const;

const ES: Translation<DashboardCatalog> = {
  screenTitle: "Panel · {product}",
  navDashboard: "Panel",
  placeholder: "Busca páginas, o inicia un análisis o una campaña",
  placeholderWithoutOutreach: "Busca páginas, o inicia un análisis",
  suggestFindLeads: "Encuentra leads entre los seguidores",
  suggestWriteCampaign: "Escribe una campaña",
  suggestSearchAccounts: "Busca cuentas por nicho",
  newsLabel: "Nuevo",
  newsText: "Compra dominios y buzones, ya calentados para ti",
  goodMorning: "Buenos días",
  goodAfternoon: "Buenas tardes",
  goodEvening: "Buenas noches",
  greetingWithName: "{greeting}, {name}",
};

export const DASHBOARD_CATALOGS: Catalogs<DashboardCatalog> = { en: EN, es: ES };
